import { render, staticRenderFns } from "./companyVerification.vue?vue&type=template&id=34f80d3f&scoped=true&"
import script from "./companyVerification.vue?vue&type=script&lang=js&"
export * from "./companyVerification.vue?vue&type=script&lang=js&"
import style0 from "./companyVerification.vue?vue&type=style&index=0&id=34f80d3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f80d3f",
  null
  
)

export default component.exports